import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../css/Commerce.css";
import drop3img from "../../../images/catalogdrop3.png";

const CommerceSettings = () => {
  const [openDropdown, setOpenDropdown] = useState(null);


  const toggleDropdown = (index) => {
    setOpenDropdown(openDropdown === index ? null : index);
  };

  return (
    <div className="container-fluid p-4">
      <div className="bg-light p-3 rounded shadow-sm commerce-settings-header">
        <div className="d-flex justify-content-between">
          <h5 className="fw-bold">Commerce Settings</h5>
          <a href="###">
            Give your Feedback <i className="bi bi-box-arrow-up-right"></i>
          </a>
        </div>
        <p>Set up WhatsApp Catalog Messages for your account</p>
      </div>
      <div className="bg-light p-4 rounded shadow-sm row">
        <div className="col-6">
          <h2 className="fw-bold">Start Selling on WhatsApp!</h2>
          <p>
            You can send Catalogs to customers as part of campaigns &
            autoreplies. They can then place orders via Carts.
          </p>
          <button className="btn btn-outline-dark">Learn More</button>
        </div>
        <div className="col-6 d-flex align-items-center justify-content-center">
          <iframe
            width="100%"
            height="250"
            src="https://www.youtube.com/embed/AsWJu8mOvVY?si=DpTlUWNBjlP0oLBj"
            title="YouTube video"
            style={{ border: "none" }}
            allowFullScreen
          ></iframe>
        </div>
      </div>

      {/* Dropdown 1 */}
      <div className="card mt-4">
        <div
          className="card-header d-flex justify-content-between"
          onClick={() => toggleDropdown(1)}
          style={{ cursor: "pointer" }}
        >
          <span>
            <strong>
              <i className="bi bi-1-circle-fill"></i>
            </strong>{" "}
            Add products to your WhatsApp Store
          </span>
          <span>
            {openDropdown === 1 ? (
              <i className="bi bi-caret-up-fill"></i>
            ) : (
              <i className="bi bi-caret-right-fill"></i>
            )}
          </span>
        </div>
        {openDropdown === 1 && (
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center">
              <h6>Create your catalog</h6>
              <button className="btn btn-success">Upload CSV</button>
            </div>
            <p>Add your products to the CSV and upload it here.</p>

            <hr />

            <div className="d-flex justify-content-between align-items-center">
              <h6>A. Set up FB Catalog & Collections</h6>
              <button className="btn btn-primary">Go to FB</button>
            </div>
            <p>via Google Sheets | Shopify</p>

            <hr />

            <div className="d-flex justify-content-between align-items-center">
              <h6>B. Give Catalog Access to Haptik</h6>
              <button className="btn btn-primary">Go to FB</button>
            </div>
            <p>Add Haptik (9289761175289) as Catalog Partner</p>

            <hr />

            <div className="d-flex justify-content-between align-items-center">
              <h6>C. Connect your Catalog to your WhatsApp account</h6>
              <button className="btn btn-primary">Go to FB</button>
            </div>
            <p>Go here and follow the steps shown in the video</p>

            <hr />

            <div className="d-flex justify-content-between align-items-center">
              <h6>D. Enter Facebook Catalog ID</h6>
            </div>
            <p>We will fetch products from this catalog.</p>
            <div className="d-flex justify-content-between">
              <input
                type="text"
                className="form-control me-2"
                placeholder="Enter Catalog ID"
              />
              <button className="btn btn-secondary">Connect</button>
            </div>

            <hr />

            <div className="text-end">
              <button className="btn btn-dark">Open Catalog</button>
            </div>
          </div>
        )}
      </div>

      {/* Dropdown 2 */}
      <div className="card mt-2">
        <div
          className="card-header d-flex justify-content-between"
          onClick={() => toggleDropdown(2)}
          style={{ cursor: "pointer" }}
        >
          <span>
            <strong>
              <i className="bi bi-2-circle-fill"></i>
            </strong>{" "}
            Setup Messages for Product Collections & Catalogs
          </span>
          <span>
            {openDropdown === 2 ? (
              <i className="bi bi-caret-up-fill"></i>
            ) : (
              <i className="bi bi-caret-right-fill"></i>
            )}
          </span>
        </div>
        {openDropdown === 2 && (
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center p-2">
              <p>
                You can send upto 10 of your collections as List Messages. If
                your customer clicks on a collection, 30 products from that
                collection will be sent to the customer automatically as a
                catalog message
                <i class="bi bi-play-circle-fill red-icon"></i>
              </p>
            </div>
            <a phref="###" className="p-2 small">Learn how to add collections in your FB catalog</a>
            <div className="image mb-3">
              <img src={drop3img} alt="FB Collections" className="w-100" />
            </div>

            <div>
              {/* Table Structure */}
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>FB Collections</th>
                    <th>Include in Top 10?</th>
                    <th>Set Catalog Message for every collection</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colSpan="3" className="text-muted text-center p-4">
                      <em>
                        Your Product Collections will be visible here after you
                        have connected your FB Catalog to Interakt & added
                        Product Collections in your Catalog on Facebook Commerce
                        Manager.
                      </em>
                    </td>
                  </tr>
                </tbody>
              </table>

 
              <div
                className="alert alert-warning d-flex align-items-center p-2 small"
                role="alert"
              >
                <i className="bi bi-exclamation-circle-fill me-1"></i>
                <span style={{ fontSize: "14px" }}>
                  Please sync whenever you update your FB collections
                </span>
              </div>

       
              <div className="d-flex justify-content-end align-items-center">
                <button className="btn btn-outline-success d-flex align-items-center">
                  <i className="bi bi-arrow-repeat me-2"></i> Sync
                </button>
              </div>
              <p className="text-end text-muted mt-1">
                Last Sync: 12:05 pm, 15/02/2025
              </p>
            </div>
          </div>
        )}
      </div>

      {/* Dropdown 3 */}
      <div className="card mt-2">
        <div
          className="card-header d-flex justify-content-between"
          onClick={() => toggleDropdown(3)}
          style={{ cursor: "pointer" }}
        >
          <span>
            <strong>
              <i className="bi bi-3-circle-fill"></i>
            </strong>{" "}
            Send out Catalogs in Campaigns
          </span>
          <span>
            {openDropdown === 3 ? (
              <i className="bi bi-caret-up-fill"></i>
            ) : (
              <i className="bi bi-caret-right-fill"></i>
            )}
          </span>
        </div>
        {openDropdown === 3 && (
          <div className="card-body fixed-dropdown">
            <div className="d-flex justify-content-between align-items-center">
              <p>
                After your campaign message, add an automatic catalog flow: if
                the customer clicks on the Quick Reply Button in your campaign
                message, the Product Collections List Message will go out
                automatically. If the customer then selects a collection from
                the list, the corresponding product catalog will go out
                instantly as a catalog message!{" "}
                <i class="bi bi-play-circle-fill red-icon"></i>
              </p>
            </div>
            <button className="btn btn-secondary">Setup</button>
          </div>
        )}
      </div>

      {/* Dropdown 4 */}
      <div className="card mt-2">
        <div
          className="card-header d-flex justify-content-between"
          onClick={() => toggleDropdown(4)}
          style={{ cursor: "pointer" }}
        >
          <span>
            <strong>
              <i className="bi bi-4-circle-fill"></i>
            </strong>{" "}
            Send out Catalogs in Auto Replies
          </span>
          <span>
            {openDropdown === 4 ? (
              <i className="bi bi-caret-up-fill"></i>
            ) : (
              <i className="bi bi-caret-right-fill"></i>
            )}
          </span>
        </div>
        {openDropdown === 4 && (
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center">
              <p>
                Attach your Product Collections List in your Welcome / OOO /
                Delayed Messages! As soon as the Customer selects a Collection,
                products in that Collection will automatically go out as a
                Catalog! <i class="bi bi-play-circle-fill red-icon"></i>
              </p>
            </div>
            <button className="btn btn-secondary">Setup</button>
          </div>
        )}
      </div>

      {/* Dropdown 5 */}
      <div className="card mt-2">
        <div
          className="card-header d-flex justify-content-between"
          onClick={() => toggleDropdown(5)}
          style={{ cursor: "pointer" }}
        >
          <span>
            <strong>
              <i className="bi bi-5-circle-fill"></i>
            </strong>{" "}
            Help Customers place orders with Interakt’s Auto-checkout Workflow!
          </span>
          <span>
            {openDropdown === 5 ? (
              <i className="bi bi-caret-up-fill"></i>
            ) : (
              <i className="bi bi-caret-right-fill"></i>
            )}
          </span>
        </div>
        {openDropdown === 5 && (
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center">
              <p>
                Whenever a customer sends a WhatsApp cart, the Autocheckout
                Workflow will take over! It will automatically collect the
                customer's shipping address, send payment link & make sure that
                the order is placed!
                <i class="bi bi-play-circle-fill red-icon"></i>
              </p>
            </div>
            <button className="btn btn-success">Setup</button>
          </div>
        )}
      </div>

      {/* Dropdown 6 */}
      <div className="card mt-2">
        <div
          className="card-header d-flex justify-content-between"
          onClick={() => toggleDropdown(6)}
          style={{ cursor: "pointer" }}
        >
          <span>
            <strong>
              <i className="bi bi-6-circle-fill"></i>
            </strong>{" "}
            See all enquiries & orders you get from customers
          </span>
          <p className="text-disabled">Coming Soon</p>{" "}
        </div>
        {/* {openDropdown === 6 && <div className="card-body">Details about customer enquiries & orders.</div>} */}
      </div>
    </div>
  );
};

export default CommerceSettings;
